import { Button, Label, Segment } from 'semantic-ui-react';
import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const LoginFormWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    width: 100%;

    .ui.form .field,
    .ui.form .error {
      margin-bottom: 0;
      position: relative;
      .label{       
        font-weight: 300 !important;
      }
      .prompt.label {
        position: absolute;
        left: 0;
        bottom: -0.75rem;
      }
    }
  `}
`;
const FormHeading = styled.h1`
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;
const FormParagraph = styled.p`
  font-size: 1.15rem;
`;
const FixedPrice = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 60px;
  margin-bottom: 0.5rem;
`;
const FormLogo = styled.h1`
  font-size: 2.0rem;
  line-height: 2.25rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;
const FormTermsAndPrivacy = styled.a`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  text-align: left;
  font-weight: bold;
  cursor: pointer;
  width: 200px;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    opacity: 0.7;
  }
  
 .ui.loading.segment::before {
  background: none !important;
  font-size: 5px !important;
 }
`;

export const StyledSegment = styled(Segment)`
border: none !important; 
padding: 0px !important; 
background: none !important; 
box-shadow: none !important;
`

const StyledDivResetWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const loginForm = {
  width: '450px',
  margin: 'auto',
  textAlign: 'center',
  padding: '1rem'
};

const loginFormField = {
  position: 'relative',
  minWidth: '150px',
  lineHeight: '1.25rem'
};

const loginFormRememberFieldWrapper = {
  display: 'flex',
  fontSize: '1rem',
  justifyContent: 'start'
};

const loginFormRememberField = {
  display: 'flex',
  alignItems: 'center',
  marginRight: 'auto'
};

const loginFormForgotPassword = {
  cursor: 'pointer',
  background: 'transparent',
  border: 'none',
  fontSize: '1rem'
};

const loginFormSubmitWrapper = {
  display: 'flex',
  marginTop: '0.5rem',
  paddingBottom: '0.5rem',
  justifyContent: 'center'
};

const loginFormSubmitButton = {
  justifyContent: 'center',
  borderRadius: '.375rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  paddingTop: '1rem',
  paddingBottom: '1rem',
  minWidth: '8rem',
  paddingLeft: '1.2rem',
  paddingRight: '1.2rem',
  fontSize: '1.1rem'
};

const loginFormBackIcon = {
  cursor: 'pointer',
  marginRight: '0.75rem'
};

const LandingPageContainer = styled.div<{ url: string }>`
  display: flex;
  justify-content: flex-end; 
  min-height: 100vh;
  height: 100%;
  background-image: linear-gradient(rgba(90, 90, 90, 0.4), rgba(10, 10, 10, 0.5)), url(${props => props.url});
  background-size: cover;
  background-position: center;
  animation: ${fadeIn} 0.6s ease-in; /* Apply animation */
`;

const LandingPageForm = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex-wrap: wrap;
  background-color: rgba(255, 255, 255, 0.9);
  margin: auto 70px auto 70%;
  width: 100%;
  align-items: center;
  padding: 20px;
  min-width: 550px;
  border-radius: 20px;
  .input {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const LandingPageFormFotter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0px;
`;

const FormCompanyNameVersion = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  text-align: left;
  font-weight: bold;
`;
const FormTermsWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
`;

const defaultBackground = styled.div`
  displey: flex;
  align-items: center;
  margin: auto;
`;

const StyledLabelInfo = styled(Label)`
 padding: 0.67857143em 1em !important;
 background-color: white !important;
 white-space: nowrap !important;
 width: 200px;
 cursor: default;
  .detail {
    max-width: 160px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    margin-left: 0px !important;
    font-weight: 300 !important;
    color: black !important;
  }
`
const BackButton = styled(Button)`
  background: transparent !important;
  opacity: 1 !important;
  margin-right: 1rem;
  :hover {
    color: #556080 !important;
  }
`;

const StyledBrowserImgWrapper = styled.div`
display: flex;
align-items: center;
gap: 10px;
 img {
  width: 120px;
  max-height: 105px;
 }
`

export const El = {
  loginFormBackIcon,
  loginFormSubmitButton,
  loginFormSubmitWrapper,
  loginFormForgotPassword,
  loginFormRememberField,
  loginFormRememberFieldWrapper,
  loginFormField,
  loginForm,
  FormTermsAndPrivacy,
  FormLogo,
  FormParagraph,
  FormHeading,
  LoginFormWrapper,
  StyledDivResetWrapper,
  FixedPrice,
  LandingPageContainer,
  LandingPageForm,
  LandingPageFormFotter,
  FormCompanyNameVersion,
  FormTermsWrapper,
  defaultBackground,
  StyledLabelInfo,
  BackButton,
  StyledBrowserImgWrapper
};
